/**
 * 카카오 로그인 훅 (프로모션용)
 * - 카카오 OAuth를 통해 idToken을 받아 로그인 처리
 */
export default function useKakaoLoginPromotion() {
  const handleKakaoLoginWeb = () => {
    if (!window.Kakao) {
      console.error("[Kakao Login] SDK가 로드되지 않았습니다.");
      return;
    }

    if (!window.Kakao.isInitialized()) {
      console.error("[Kakao Login] SDK가 초기화되지 않았습니다.");
      return;
    }

    window.Kakao.Auth.authorize({
      redirectUri: `${window.location.origin}/promotion/oauth/kakao`,
      scope: "account_email,openid,phone_number,plusfriends",
    });
  };

  return handleKakaoLoginWeb;
}
